module.exports = __webpack_public_path__ + "img/9788954437226.5d418191.jpg";